import {appApi} from "@src/integrations/redux/app-api";

export interface NotificationCursor {before: string; beforeId: string}
export interface RideNotification {
  notifId: string; contextId: string; title: string; body: string; notifType: string;
  logTime: string; unread: boolean; unseen: boolean;
}
export const notificationsApi = appApi.enhanceEndpoints({addTagTypes: ['RideNotifications']}).injectEndpoints({
  endpoints: builder => ({
    notifications: builder.query<{items: RideNotification[]; nextCursor: NotificationCursor | null}, {accountId: string; cursor?: NotificationCursor}>({
      // accountId isolates the client cache; the server always uses its verified session.
      query: ({cursor}) => ({url: '/api/v1/notifications', params: cursor}),
      providesTags: ['RideNotifications'], keepUnusedDataFor: 0,
    }),
    readNotifications: builder.mutation<void, string[]>({
      query: ids => ({url: '/api/v1/notifications/read', method: 'POST', body: {ids}}),
      invalidatesTags: (_data, error) => error ? [] : ['RideNotifications'],
    }),
  }),
});
export const {useNotificationsQuery, useReadNotificationsMutation} = notificationsApi;
